// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectAll_wrapper__2WB2G"};